import { apiGet } from "../baseApi";
import { setDomainData } from "service/mapper";

export const getById = async (id, cancelToken = null) => {
  try {
    const response = await apiGet("_domain", {}, id, { cancelToken });
    return { ...response, data: setDomainData(response.data) };
  } catch (error) {
    return Promise.reject(error);
  }
};
